import {Flex} from "@chakra-ui/react";

const NoCover = ({size = '317px', minH = '317px', title = "Brak zdjęcia okładkowego", padding = 0}) => {
    return <Flex
        align="center"
        justify="center"
        w={{base: "100%", md: size}}
        h={{base: "100%", md: size}}
        minW={size}
        minH={{base: minH, md: "100%"}}
        bg="gray.200"
        color="gray.600"
        fontFamily="Poppins"
        fontSize="16px"
        fontWeight="500"
        textAlign="center"
        p={padding}
    >
        {title}
    </Flex>
}
export default NoCover;
